import configureWevo from "./configure-wevo";
import devices from "./devices";
import entities from "./entities";
import notifications from "./notifications";
import queryString from "./queryString";
import session from "./session";
import title from "./title";
import user from "./user";
import wevos from "./wevos";
import resultsExport from "./results-export";
import audiences from "./audiences";
import pages from "./pages/reducer";
import * as results from "./results";
import * as app from "./app";
import * as api from "./api";
import * as drivers from "./drivers";
import * as dashboard from "./dashboard";

// the following modules don't have reducers:
// * ctas
// * images

// TODO the following modules have broken reducers:
// * audiences

const reducers = {
    audiences,
    api: api.reducer,
    app: app.reducer,
    boards: wevos,
    configureWevo,
    dashboard: dashboard.reducer,
    devices,
    drivers: drivers.reducer,
    entities,
    notifications,
    pages,
    queryString,
    results: results.reducer,
    resultsExport,
    session,
    title,
    user
};

export default reducers;



// WEBPACK FOOTER //
// ./src/modules/index.js